/**
 * RebookTruncatedNotice — shown when the targets endpoint hit its row cap, so
 * the month on screen is not the whole month (BON-146).
 *
 * Worth its own strip rather than silence: the failure mode this prevents is a
 * CSR scanning a month, not finding the date a customer asked for, and telling
 * them it does not exist — when in fact it was past the cap. Narrowing by tree
 * type is the fix, so the notice says so.
 */
import { AlertTriangle } from 'lucide-react';

export function RebookTruncatedNotice() {
  return (
    <div className="flex items-start gap-2 border-b border-amber-200 bg-amber-50 px-5 py-2.5 text-xs text-amber-900 dark:border-amber-900/40 dark:bg-amber-900/15 dark:text-amber-200">
      <AlertTriangle size={14} className="mt-px flex-shrink-0" />
      <span>
        Too many workshops to show at once — this month is only partly listed. Filter by tree type,
        or move a month at a time, to be sure you are seeing everything.
      </span>
    </div>
  );
}
